import React from 'react';
import { formatReportPeriod } from '../format';
import {
    SHEET_COLUMNS,
    buildSheetTotals,
    downloadSheetExcel,
    formatSheetCell,
} from '../motivation/sheet';

const Icon = ({ d }) => (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d={d} />
    </svg>
);

const LOCKED_STATUSES = ['Approved', 'Accepted'];
const BONUS_KEYS = { bonusPercent: 'percent', bonusPay: 'amount' };

const PayrollTableModal = ({ open, period, rows, loading, onClose, onOpenRow, onChangeBonus, onSaveBonus }) => {
    if (!open) return null;

    const totals = rows.length ? buildSheetTotals(rows) : null;

    return (
        <div className="pc-emp-ov" onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}>
            <div className="pc-emp-modal pc-emp-modal--sheet" role="dialog" aria-modal="true" aria-labelledby="pc-sheet-title">
                <div className="pc-emp-mh">
                    <div>
                        <h3 id="pc-sheet-title">Таблица расчёта</h3>
                        <div className="sub">
                            {formatReportPeriod(period)} · {rows.length ? `${rows.length} строк` : 'нет данных'} · премию можно править в колонках «Премия, %» и «Премия»
                        </div>
                    </div>
                    <button type="button" className="pc-emp-btn pc-emp-btn--ico pc-emp-btn--quiet" onClick={onClose} title="Закрыть">
                        <Icon d="M4 4l8 8M12 4L4 12" />
                    </button>
                </div>
                <div className="pc-sheet-wrap">
                    {loading ? (
                        <div className="pc-emp-empty"><p>Загрузка таблицы…</p></div>
                    ) : rows.length === 0 ? (
                        <div className="pc-emp-empty">
                            <b>Нет строк</b>
                            <p>Сначала запустите расчёт за выбранный период.</p>
                        </div>
                    ) : (
                        <table className="pc-sheet">
                            <thead>
                                <tr>
                                    {SHEET_COLUMNS.map((column) => (
                                        <th key={column.key} style={{ minWidth: column.width }}>{column.title}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row) => {
                                    const locked = LOCKED_STATUSES.includes(row.status);
                                    return (
                                        <tr
                                            key={row.id || `${row.login}-${row.name}`}
                                            onClick={() => { if (onOpenRow && row.id) onOpenRow(row.id); }}
                                        >
                                            {SHEET_COLUMNS.map((column) => {
                                                const bonusField = BONUS_KEYS[column.key];
                                                if (bonusField && onChangeBonus && !locked) {
                                                    return (
                                                        <td key={column.key} className="num" onClick={(event) => event.stopPropagation()}>
                                                            <input
                                                                className="pc-sheet-inp"
                                                                type="number"
                                                                step={bonusField === 'percent' ? '1' : '0.01'}
                                                                min="0"
                                                                value={row[column.key] == null ? '' : row[column.key]}
                                                                onChange={(event) => onChangeBonus(row.id, { [bonusField]: event.target.value })}
                                                                onBlur={() => { if (onSaveBonus) onSaveBonus(row.id); }}
                                                            />
                                                        </td>
                                                    );
                                                }
                                                return (
                                                    <td key={column.key} className={column.kind === 'text' ? '' : 'num'}>
                                                        {formatSheetCell(column, row[column.key])}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                            {totals ? (
                                <tfoot>
                                    <tr>
                                        {SHEET_COLUMNS.map((column) => (
                                            <td key={column.key} className={column.kind === 'text' ? '' : 'num'}>
                                                {formatSheetCell(column, totals[column.key])}
                                            </td>
                                        ))}
                                    </tr>
                                </tfoot>
                            ) : null}
                        </table>
                    )}
                </div>
                <div className="pc-emp-mf">
                    <button
                        type="button"
                        className="pc-emp-btn pc-emp-btn--pri"
                        disabled={!rows.length}
                        onClick={() => downloadSheetExcel(rows, period)}
                    >
                        Скачать Excel
                    </button>
                    <button type="button" className="pc-emp-btn" onClick={onClose}>Закрыть</button>
                </div>
            </div>
        </div>
    );
};

export default PayrollTableModal;
